import { withLazy } from 'app/hocs/withLazy'

export const Admin = withLazy(() => import('features/Admin/pages/Admin'))
